// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { DepartmentFragment } from '../../../../settings/graphql/fragments/generated/city-tax-department.fragment.generated';
export type CashRegisterItemFragment = { __typename?: 'CashRegisterItemDTO', amount: number | null, description: string | null, note: string | null, type: Types.CashRegisterItemTypeEnumDto, department: { __typename?: 'DepartmentDTO', atecoCodeId: number | null, cashRegisterCode: string | null, description: string, id: number, sellGoods: boolean, vatRateId: number, atecoCode: { __typename?: 'AtecoCodeDTO', cashRegisterCode: string | null, code: string, description: string, id: number, ownerId: number } | null, vatRate: { __typename?: 'VatRateDTO', atecoCodeId: number | null, cashRegisterCode: string | null, description: string, id: number, ownerId: number, rate: number, referenceOnZeroVat: string | null, naturaTypeOnZeroVat: Types.NaturaTypeEnumDto | null, atecoCode: { __typename?: 'AtecoCodeDTO', cashRegisterCode: string | null, code: string, description: string, id: number, ownerId: number } | null } } | null };

export const CashRegisterItemFragment = gql`
    fragment CashRegisterItem on CashRegisterItemDTO {
  amount
  department {
    ...Department
  }
  description
  note
  type
}
    ${DepartmentFragment}`;
/* eslint-enable */